<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/@vxapp/Auth/useAuthStore'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { AccessPageMeta } from '@/access/accessPageMeta'
import { googleCallbackResult } from '@/access/googleCallback'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'

definePage({ meta: AccessPageMeta.GoogleOAuth.Meta })
setPageTitle(AccessPageMeta.GoogleOAuth.Title)

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()
const result = ref<'linked' | 'failed' | null>(null)
const ready = ref(false)

onMounted(async () => {
  const validated = googleCallbackResult(route.query)

  await router.replace({ query: {}, hash: '' })
  result.value = validated
  ready.value = true
})
</script>

<template>
  <VCard
    class="ma-6"
    data-testid="google-oauth-completion"
  >
    <VCardTitle>Google connection</VCardTitle>
    <VCardText v-if="ready">
      <p v-if="result === 'linked'">Google connection linked.</p>
      <p v-else>Google connection could not be completed.</p>
      <VBtn
        v-if="auth.isAuthenticated && auth.isUser && !auth.isTokenExpired"
        :to="{ name: AccessPageMeta.GoogleConnection.Name }"
        >Google connection</VBtn
      >
      <VBtn
        v-else
        :to="{ name: PageMeta.Auth.login.name }"
        >Sign in</VBtn
      >
    </VCardText>
    <VCardText v-else>Completing connection…</VCardText>
  </VCard>
</template>
